Pixlee.module('Behaviors', function(Behaviors, App, Backbone, Marionette, $) {
    Behaviors.UploadContentValidation = Marionette.Behavior.extend({
        ui: {
            nextPanel: '#next',
            dragDropTitle: '#drag_drop_title'
        },
        onShow: function() {
            this.ui.nextPanel.one('click', this.submitValidation.bind(this));
        },
        submitValidation: function(ev) {
            var requiredFields = this.$el.find('.required');
            var success = true;
            var firstErrorFound = true;
            $.each(requiredFields, function(index, field) {
                var photoHolder = $(field).parent();
                if (_.isFalsy(field.value)) {
                    success = false;
                    photoHolder.addClass('error');
                    // have screen reader read out "required" when tabbing over textarea
                    $(field).attr('aria-required', 'true');
                    if (firstErrorFound) {
                        $(field).focus();
                        firstErrorFound = false;
                    }
                } else {
                    photoHolder.removeClass('error');
                }
            });
            if (success) {
                this.view.triggerMethod('show:submit:content:panel');
            } else {
                this.ui.nextPanel.one('click', this.submitValidation.bind(this));
            }
        }
    });
});